/**
 * 右ペイン「グラフ設定」の開閉を、グラフ種類ツールバー等から共有する。
 */

import { createContext, useContext } from 'react';

export type KeisukeChartSettingsUi = {
  open: boolean;
  toggle: () => void;
};

const KeisukeChartSettingsUiContext = createContext<KeisukeChartSettingsUi | null>(null);

export const KeisukeChartSettingsUiProvider = KeisukeChartSettingsUiContext.Provider;

export function useKeisukeChartSettingsUi(): KeisukeChartSettingsUi | null {
  return useContext(KeisukeChartSettingsUiContext);
}
